function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { MoneyModel, timeModel } from "./";
import { PayoutIntegrationModel } from "./PayoutIntegrationModel";
import { InvoiceIntegrationModel } from "./InvoiceIntegrationModel";
import { Accounting } from "../types/api.model";
export let ScoutPayoutFailureCode = /*#__PURE__*/function (ScoutPayoutFailureCode) {
  ScoutPayoutFailureCode["InvalidAccountNumber"] = "invalid_account_number";
  ScoutPayoutFailureCode["BankAccountRestricted"] = "bank_account_restricted";
  ScoutPayoutFailureCode["AccountClosed"] = "account_closed";
  ScoutPayoutFailureCode["NoAccount"] = "no_account";
  ScoutPayoutFailureCode["DebitNotAuthorized"] = "debit_not_authorized";
  ScoutPayoutFailureCode["InsufficientFunds"] = "insufficient_funds";
  ScoutPayoutFailureCode["AccountFrozen"] = "account_frozen";
  ScoutPayoutFailureCode["RefusedByReceiver"] = "refused_by_receiver";
  ScoutPayoutFailureCode["MissingAuthorization"] = "missing_authorization";
  return ScoutPayoutFailureCode;
}({});
export let PayoutStatus = /*#__PURE__*/function (PayoutStatus) {
  PayoutStatus["Paid"] = "paid";
  PayoutStatus["Failed"] = "failed";
  return PayoutStatus;
}({});
export let PayoutFailureCode = /*#__PURE__*/function (PayoutFailureCode) {
  PayoutFailureCode["InvalidAccountNumber"] = "invalid_account_number";
  PayoutFailureCode["BankAccountRestricted"] = "bank_account_restricted";
  PayoutFailureCode["AccountClosed"] = "account_closed";
  PayoutFailureCode["NoAccount"] = "no_account";
  PayoutFailureCode["DebitNotAuthorized"] = "debit_not_authorized";
  PayoutFailureCode["InsufficientFunds"] = "insufficient_funds";
  PayoutFailureCode["AccountFrozen"] = "account_frozen";
  PayoutFailureCode["RefusedByReceiver"] = "refused_by_receiver";
  PayoutFailureCode["MissingAuthorization"] = "missing_authorization";
  return PayoutFailureCode;
}({});
export let PayoutInvoiceType = /*#__PURE__*/function (PayoutInvoiceType) {
  PayoutInvoiceType["Payment"] = "Payment";
  PayoutInvoiceType["Refund"] = "Refund";
  PayoutInvoiceType["Dispute"] = "Dispute";
  return PayoutInvoiceType;
}({});
export class PayoutModel {
  static fromDTO(dto) {
    var _dto$integrations;
    return new PayoutModel({
      id: dto.id,
      createdAt: dto.createdAt,
      amount: MoneyModel.fromDTO(dto.amount),
      status: dto.status,
      invoices: dto.invoices.map(PayoutModel.fromPayoutInvoiceDTO),
      integrations: PayoutIntegrationModel.fromAccountingDTO((_dto$integrations = dto.integrations) !== null && _dto$integrations !== void 0 ? _dto$integrations : []),
      payoutFailure: dto.payoutFailure,
      formattedNumber: dto.formattedNumber
    });
  }
  static fromScoutDTO(dto) {
    var _dto$integrations2;
    return new PayoutModel({
      id: dto.id,
      createdAt: dto.depositDate,
      amount: new MoneyModel(new Decimal(dto.amount)),
      status: dto.status,
      invoices: dto.invoices.map(PayoutModel.fromScoutInvoiceDTO),
      integrations: PayoutIntegrationModel.fromAccountingDTO((_dto$integrations2 = dto.integrations) !== null && _dto$integrations2 !== void 0 ? _dto$integrations2 : []),
      payoutFailure: dto.payoutFailure,
      formattedNumber: dto.formattedNumber
    });
  }
  static fromPayoutInvoiceDTO(dto) {
    const zeroFee = new MoneyModel(new Decimal(0));
    const fee = dto.fee ? MoneyModel.fromDTO(dto.fee) : zeroFee;
    const processingFee = MoneyModel.fromDTO(dto.processingFee);
    const customerProcessingFee = MoneyModel.fromDTO(dto.customerProcessingFee);
    const disputeFee = MoneyModel.fromDTO(dto.disputeFee);
    const totalAmount = MoneyModel.fromDTO(dto.totalAmount);
    const depositAmount = MoneyModel.fromDTO(dto.depositAmount);
    const serviceFeeRefund = MoneyModel.fromDTO(dto.serviceFeeRefund);
    return {
      id: dto.id,
      type: dto.type,
      relationshipId: dto.relationshipId,
      createdOn: timeModel.toDate(dto.createdOn),
      dueDate: timeModel.toDate(dto.dueDate),
      number: dto.number,
      formattedNumber: dto.formattedNumber,
      title: dto.title,
      customer: dto.customer,
      fee,
      processingFee,
      customerProcessingFee,
      disputeFee,
      serviceFeeRefund,
      totalFees: fee.add(processingFee).add(customerProcessingFee).add(disputeFee).add(serviceFeeRefund),
      totalAmount,
      depositAmount,
      integrations: dto.integrations && InvoiceIntegrationModel.fromAccountingDTO(dto.integrations, totalAmount.isZero())
    };
  }
  static fromScoutInvoiceDTO(dto) {
    const zeroFee = new MoneyModel(new Decimal(0));
    const fee = dto.fee ? new MoneyModel(new Decimal(dto.fee)) : zeroFee;
    const processingFee = new MoneyModel(new Decimal(dto.processingFee));
    const customerProcessingFee = new MoneyModel(new Decimal(dto.customerProcessingFee));
    const disputeFee = new MoneyModel(new Decimal(dto.disputeFee));
    const totalAmount = new MoneyModel(new Decimal(dto.totalAmount));
    const depositAmount = new MoneyModel(new Decimal(dto.depositAmount));
    const serviceFeeRefund = new MoneyModel(new Decimal(dto.serviceFeeRefund));
    return {
      id: dto.id,
      type: dto.type,
      relationshipId: dto.relationshipId,
      createdOn: timeModel.toDate(dto.createdOn),
      dueDate: timeModel.toDate(dto.dueDate),
      number: dto.number,
      formattedNumber: dto.formattedNumber,
      title: '',
      customer: dto.customer,
      fee,
      processingFee,
      customerProcessingFee,
      disputeFee,
      serviceFeeRefund,
      totalFees: fee.add(processingFee).add(customerProcessingFee).add(disputeFee).add(serviceFeeRefund),
      totalAmount,
      depositAmount,
      integrations: dto.integrations && InvoiceIntegrationModel.fromAccountingDTO(dto.integrations, totalAmount.isZero())
    };
  }
  constructor(data) {
    this.data = data;
  }
  xeroIntegration() {
    var _this$data$integratio;
    return (_this$data$integratio = this.data.integrations) === null || _this$data$integratio === void 0 || (_this$data$integratio = _this$data$integratio.find(integration => integration.type === Accounting.Xero)) === null || _this$data$integratio === void 0 ? void 0 : _this$data$integratio.integration;
  }
  xeroIntegrationForInvoice(id) {
    var _this$data$invoices$f;
    return (_this$data$invoices$f = this.data.invoices.find(i => i.id === id)) === null || _this$data$invoices$f === void 0 || (_this$data$invoices$f = _this$data$invoices$f.integrations) === null || _this$data$invoices$f === void 0 ? void 0 : _this$data$invoices$f.find(i => i.type === Accounting.Xero);
  }
  qboIntegration() {
    var _this$data$integratio2;
    return (_this$data$integratio2 = this.data.integrations) === null || _this$data$integratio2 === void 0 || (_this$data$integratio2 = _this$data$integratio2.find(integration => integration.type === Accounting.QBO)) === null || _this$data$integratio2 === void 0 ? void 0 : _this$data$integratio2.integration;
  }
  qboIntegrationForInvoice(id) {
    var _this$data$invoices$f2;
    return (_this$data$invoices$f2 = this.data.invoices.find(i => i.id === id)) === null || _this$data$invoices$f2 === void 0 || (_this$data$invoices$f2 = _this$data$invoices$f2.integrations) === null || _this$data$invoices$f2 === void 0 ? void 0 : _this$data$invoices$f2.find(i => i.type === Accounting.QBO);
  }
  accountingIntegration(accounting) {
    var _this$data$integratio3;
    return (_this$data$integratio3 = this.data.integrations) === null || _this$data$integratio3 === void 0 || (_this$data$integratio3 = _this$data$integratio3.find(integration => integration.type === accounting)) === null || _this$data$integratio3 === void 0 ? void 0 : _this$data$integratio3.integration;
  }
  isPaid() {
    return this.data.status === PayoutStatus.Paid;
  }
  isQboSynced() {
    var _this$qboIntegration;
    return !!((_this$qboIntegration = this.qboIntegration()) !== null && _this$qboIntegration !== void 0 && _this$qboIntegration.isSynced());
  }
  isXeroSynced() {
    var _this$xeroIntegration;
    return !!((_this$xeroIntegration = this.xeroIntegration()) !== null && _this$xeroIntegration !== void 0 && _this$xeroIntegration.isSynced());
  }
  payoutFailure() {
    return this.data.payoutFailure;
  }
  amount() {
    return this.data.amount;
  }
  id() {
    return this.data.id;
  }
  createdAt() {
    return this.data.createdAt;
  }
  status() {
    return this.data.status;
  }
  formattedCreatedAt() {
    return timeModel.formatDate(this.data.createdAt);
  }
  invoices() {
    return this.data.invoices;
  }
  formattedNumber() {
    return this.data.formattedNumber;
  }
  setIntegrations(integrations) {
    const updatedIntegrations = PayoutIntegrationModel.fromAccountingDTO(integrations);
    const updatedData = _objectSpread(_objectSpread({}, this.data), {}, {
      integrations: updatedIntegrations
    });
    return new PayoutModel(updatedData);
  }
}